export default __webpack_public_path__ + "static/media/addGroupNoteIcon.3afdda85.svg";